import {
  AnyAction,
  createListenerMiddleware,
  isAnyOf,
  ListenerMiddlewareInstance,
  ThunkDispatch,
  UnsubscribeListener,
} from '@reduxjs/toolkit';

import { AppRootState } from '../../../store/models/app-state.model';
import { CampaignsFilterListenerEffect } from '../effects/campaigns-filter-listener.effect';
import {
  addPagination,
  filterCampaignsByBrand,
  filterCampaignsByModels,
  filterCampaignsByName,
  filterCampaignsByStatus,
  resetPagination,
} from '../store/slices/campaigns.slice';

export const campaignsFilterListener: ListenerMiddlewareInstance<
  AppRootState,
  ThunkDispatch<AppRootState, undefined, AnyAction>
> = createListenerMiddleware();

export const unsubscribeAppsFilterListener: UnsubscribeListener =
  campaignsFilterListener.startListening({
    matcher: isAnyOf(
      filterCampaignsByName,
      filterCampaignsByBrand,
      filterCampaignsByModels,
      filterCampaignsByStatus,
      addPagination,
      resetPagination
    ),
    effect: CampaignsFilterListenerEffect,
  });
